import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SCHOOL_LAB_POC } from "../../apiRoutes";
import axiosAuth from "../../../axiosAuth";

interface UpdateSchoolPocRequest {
  schoolId: string;
  data: {
    pocList: {
      pocId: string; // Required for existing POCs
      pocName: string;
      pocDesignation: string;
      pocDepartment?: string;
      pocPhone: string;
      pocEmail: string;
    }[];
  };
}

interface UpdateSchoolPocResponse {
  success: boolean;
  message: string;
  data: {
    id: string;
    pocName: string;
    pocDesignation: string;
    pocDepartment?: string;
    pocPhone: string;
    pocEmail: string;
    schoolId: string;
  }[];
}

export const useUpdateSchoolPocMutation = (options?: {
  onSuccess?: (data: UpdateSchoolPocResponse) => void;
  onError?: (error: any) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: UpdateSchoolPocRequest): Promise<UpdateSchoolPocResponse> => {
      const response = await axiosAuth.put(SCHOOL_LAB_POC + request.schoolId + "/", request.data);
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate and refetch school POCs
      queryClient.invalidateQueries({ queryKey: ["schoolPocs"] });
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
};
